export class Secrets {
    public static FirebaseConfig: any = {
        apiKey: "AIzaSyCOZpqsg95UeG6Xn0TQZ4lQfQZ7hY_-7Og",
        authDomain: "selections-game.firebaseapp.com",
        projectId: "selections-game",
        storageBucket: "selections-game.appspot.com",
        messagingSenderId: "405547706703",
        appId: "1:405547706703:web:bbf5bfde70c68ea1f47d3a",
        measurementId: "G-DYNRQWZ7BX"
    }
}

export class PlayerCreds {
    public static email: string = "player@selections-game.com";
    public static password: string = "100%SelectionsGame";
}
